import 'emoji-mart/css/emoji-mart.css'
import './styles.scss'
import React from 'react'
import { Badge } from 'reactstrap'

import ModalWrapper from 'components/ModalWrapper'
import ModalButtons from 'components/Form/TextEditor/ModalButtons'
import AudioRecorder from 'components/AudioRecorder'
import { ButtonSpeechTranscription, ChatSubmitButton } from 'components/common'
import UploadFiles from '../../../../UploadFiles'
import EmojiSelector from '../../../../EmojiSelector'
import Camera from '../../../../Camera'
import SelectTemplateOutTime from '../../../SelectTemplateOutTime'
import ChatSyncAccount from '../../ChatSyncAccount'
import Browser from 'utils/Browser'
import { getStaticImage } from 'utils/statics'
import { FILE_MAX_SIZE_CONVERSATION } from 'constants/filesMaxSize'
import FilterMenu from 'components/FilterMenu'
import { lang } from 'utils/helpers'
import AISuggestionButton from '../AISuggestionButton'

const ActionsBar = ({
  disableComposer, conversationUser, channel, isVirtualAssistantActive,
  composer, setShowAIResponses, showAIResponses, isChatmail,
  currentCampaing, isOnline, useTemplate, withTag, show, provider,
  updateEditor, onToggleButtons, disabledSend, onToggleReset,
  isInstagramPost, onToggleModal, onToggleNote,
  setShowAudioRecorder, setShowCamera, setShowVideo, onToggleEmojis,
  showEmojis, onSelectEmoji, toggleOpenSendMessage, onSendMessage,
  showCamera, sendPhoto, showVideo, sendVideo, uploading, uploadAudio,
  showAudioRecorder, showModalButtons, composerAction, showModal, files,
  acceptTypes, setVaSuggestion
}) => {
  const supportVideoCamera = Browser.supportVideoCamera()

  const selectResponse = (suggestion) => {
    const {
      content, attachments, buttons, logId, id, confidence
    } = suggestion

    updateEditor(content)
    composerAction.updateMessage(content)
    composerAction.setFiles(attachments || [])
    composerAction.updateButtons(buttons || [])
    setShowAIResponses(false)
    setVaSuggestion({
      logId, confidence, id, content,
      withChanges: false
    })
  }

  return (
    <div
      className={`
        actions-bar
        ${disableComposer(conversationUser.isOnline, channel) ? 'disable-composer' : null}
      `}
      style={{
        display: (isOnline || composer.messageType === 'note' || (channel !== 'whatsapp' && useTemplate))
          ? 'flex'
          : 'none'
      }}
    >
      <div className='actions-bar__actions-container'>
        {
          isVirtualAssistantActive ? (
            <AISuggestionButton
              isOpen={showAIResponses}
              conversationId={conversationUser.id}
              onClick={(data) => setShowAIResponses(data)}
              onSelectItem={(data) => selectResponse(data)}
              suggestions={composer.suggestions}
            />
          ) : null
        }

        {/* CAMPAIGN */}
        {currentCampaing ? (
          <div className='actions-bar__current-campaign actions-bar__icon-btn'>
            <figure title={lang('dashboard_campaign')}>
              <img src={getStaticImage('/icons/orange-brand/icon-campaign.svg')} alt={currentCampaing} />
            </figure>
            <p>{currentCampaing}</p>
          </div>
        ) : null}

        {/* NOTES */}
        {!composer.isDeferred ? (
          <button
            type='button'
            title={lang('dashboard_send-note')}
            className='actions-bar__icon-btn'
            onClick={onToggleNote}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-note.svg')} alt='Note' />
            </figure>
          </button>
        ) : null}

        {/* CHAT SYNC */}
        {isChatmail && <ChatSyncAccount userId={conversationUser._id} />}
      </div>
      <div className='actions-bar__actions-container' >
        {/* RESET COMPOSER */}
        {!disabledSend || composer.buttons?.length ? (
          <button
            type='button'
            title={lang('dashboard_clean')}
            className='actions-bar__reset-composer-btn'
            onClick={onToggleReset}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-close.svg')} alt='Reset' />
            </figure>
          </button>
        ) : null}

        {/* OUT TIME TEMPLATES */}
        {withTag && show && useTemplate && channel !== 'whatsapp' ? (
          <SelectTemplateOutTime
            channel={channel}
            provider={provider}
            token={conversationUser?.channels?.[0]?.token}
            userId={conversationUser.id}
            updateTextEditor={updateEditor}
          />
        ) : null}

        {/* BUTTONS */}
        {composer.buttons.length > 0 ? (
          <button
            type='button'
            title={lang('dashboard_buttons')}
            className='actions-bar__buttons-composer'
            onClick={onToggleButtons}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-button-grey.svg')} alt='Button' />
            </figure>
            <div className='actions-bar__buttons-badge'>
              <Badge color={'warning'} pill>
                {composer.buttons.length}
              </Badge>
            </div>
          </button>
        ) : null}

        {/* FILTER */}
        <FilterMenu />

        {/* ATTACHMENTS */}
        {!isInstagramPost ? (
          <button
            type='button'
            title={lang('dashboard_add-attachments')}
            className='actions-bar__icon-btn'
            onClick={onToggleModal}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-clip-grey.svg')} alt='Attachments' />
            </figure>
          </button>
        ) : null}

        {/* AUDIO TRANSCRIPTION */}
        <ButtonSpeechTranscription composerMessage={composer.message}/>

        {/* AUDIO RECORDER */}
        {!isInstagramPost ? (
          <button
            type='button'
            title={lang('dashboard_record-voice-memo')}
            className='actions-bar__icon-btn'
            onClick={() => setShowAudioRecorder(true)}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-mic-grey.svg')} alt='Audio recorder' />
            </figure>
          </button>
        ) : null}

        {/* CAMERA */}
        {!isInstagramPost ? (
          <button
            type='button'
            title={lang('dashboard_capture-photo')}
            className='actions-bar__icon-btn'
            onClick={() => setShowCamera(true)}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-camera-grey.svg')} alt='camera' />
            </figure>
          </button>
        ) : null}

        {/* VIDEO CAMERA */}
        {supportVideoCamera && !isInstagramPost ? (
          <button
            type='button'
            title={lang('dashboard_record-video')}
            className='actions-bar__icon-btn'
            onClick={() => setShowVideo(true)}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-video-grey.svg')} alt='Video' />
            </figure>
          </button>
        ) : null}

        {/* EMOJIS */}
        <div className='actions-bar__emojis'>
          <button
            type='button'
            title='Emojis'
            className='actions-bar__icon-btn'
            onClick={onToggleEmojis}
          >
            <figure>
              <img src={getStaticImage('/icons/orange-brand/icon-emoji-grey.svg')} alt='Emojis' />
            </figure>
          </button>

          {/* MODAL - EMOJIS */}
          <EmojiSelector
            showEmojis={showEmojis}
            handleToggle={onToggleEmojis}
            handleSelect={onSelectEmoji}
          />
        </div>

        {/* SUBMIT BUTTON */}
        <ChatSubmitButton
          iconTypeName={composer.isDeferred
            ? 'send-deferred'
            : 'send'
          }
          value={composer.isDeferred
            ? lang('dashboard_schedule-send')
            : composer.isWallEnabledForSMS
              ? lang('dashboard_send-sms')
              : lang('dashboard_send')
          }
          isDisabled={disabledSend}
          onClick={composer.isWallEnabledForSMS
            ? toggleOpenSendMessage
            : onSendMessage
          }
        />
      </div>

      {/* MODAL - CAMERA (PHOTO) */}
      <Camera
        type='photo'
        showCamera={showCamera}
        onCloseModal={() => setShowCamera(false)}
        sendData={sendPhoto}
      />

      {/* MODAL - CAMERA (VIDEO) */}
      <Camera
        type='video'
        showCamera={showVideo}
        onCloseModal={() => setShowVideo(false)}
        sendData={sendVideo}
        uploading={uploading}
      />

      {/* MODAL - AUDIO RECORDER */}
      <AudioRecorder
        uploadAudio={uploadAudio}
        showAudioRecorder={showAudioRecorder}
        onCloseModal={() => setShowAudioRecorder(false)}
        uploading={uploading}
      />

      {/* MODAL - BUTTONS */}
      <ModalButtons
        isOpenModal={showModalButtons}
        setIsOpenModal={onToggleButtons}
        templateButtons={composer.buttons || []}
        setTemplateButtons={composerAction.updateButtons}
      />

      {/* MODAL - ATTACHMENTS */}
      <ModalWrapper
        isOpen={showModal}
        toggle={onToggleModal}
        header={lang('dashboard_upload-files')}
        body={
          <UploadFiles
            removeOnDrop={channel === 'facebook_post' ? true : false}
            multiple={channel === 'facebook_post' ? false : true}
            uploadFiles={composerAction.uploadFiles}
            cancel={onToggleModal}
            filesUploaded={files}
            onRemoveUploadedFile={composerAction.removeFile}
            uploading={uploading}
            maxSize={FILE_MAX_SIZE_CONVERSATION}
            messageErrorSize={lang('file-too-big')}
            acceptTypes={acceptTypes}
          />
        }
      />
    </div>
  )
}

export default ActionsBar
